import { render } from "./NewBusiness.vue?vue&type=template&id=6605a1da&scoped=true"
import script from "./NewBusiness.vue?vue&type=script&lang=js"
export * from "./NewBusiness.vue?vue&type=script&lang=js"

import "./NewBusiness.vue?vue&type=style&index=0&id=6605a1da&lang=scss&scoped=true"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6605a1da"]])

export default __exports__